import angular from 'angular';

let DISPLAY_STATE_TO_LISTING_STATE = {
  'upcoming': 'Coming Soon'
};

module.exports = angular.module('common.filters.listing-state', [])
.filter('listingState', function(capitalizeFilter) {
  return function(displayState) {
    return capitalizeFilter(DISPLAY_STATE_TO_LISTING_STATE[displayState] || displayState);
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/listing-state.js
 **/